import {createSlice} from "@reduxjs/toolkit";

const notificationSlice = createSlice({
    name : "notification",
    initialState : {
        toastMessage : "",
        toastType: "",
        showToast : false
    },
    reducers : {
        setNotification : (state, action) => {
            state.showToast = action.payload.showToast;
            state.toastMessage = action.payload.toastMessage;
            state.toastType= action.payload.toastType;
        },
        resetNotification : (state) => {
            state.showToast = false;
            state.toastMessage = "";
            state.toastType= "";
        }
    }
})

const {actions, reducer} = notificationSlice;

export const {setNotification, resetNotification} = actions;

export default reducer;